// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1jUTF","label":"CategoryService_label__36q26","location":"CategoryService_location__1vGJJ"};